import React from "react";
import DatePicker from "@wojtekmaj/react-daterange-picker";
import "./style.css";
const DateFilter = React.forwardRef((props, ref) => (
  <DatePicker
    className="react-daterange-picker-style"
    format="y-MM-d"
    ref={ref}
    {...props}
  />
));
export default DateFilter;
